export default __webpack_public_path__ + "static/media/purple-marker.57b014d0.svg";